import React, { createContext, useContext, useEffect, useState } from 'react';
import { FastAverageColor } from 'fast-average-color';
import { packagingData } from '@/data/packaging';

type ColorContextType = {
    colors: Record<string, string>;
};

const ColorContext = createContext<ColorContextType>({ colors: {} });

export const useColors = () => useContext(ColorContext);

export const ColorProvider = ({ children }: { children: React.ReactNode }) => {
    const [colors, setColors] = useState<Record<string, string>>({});

    useEffect(() => {
        const fac = new FastAverageColor();
        const newColors: Record<string, string> = {};
        const promises: Promise<void>[] = [];

        packagingData.forEach((pkg) => {
            if (pkg.images && pkg.images.length > 0) {
                const imageSrc = pkg.images[0];
                // Create a detached image element for calculation
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = imageSrc;

                const p = new Promise<void>((resolve) => {
                    img.onload = () => {
                        try {
                            // Same settings as original implementation
                            const color = fac.getColor(img, { algorithm: 'simple', top: 0, height: 10 });
                            newColors[pkg.id] = color.rgba;
                        } catch (e) {
                            console.warn(`Failed to get color for ${pkg.id}`, e);
                        }
                        resolve();
                    };
                    img.onerror = () => {
                        resolve();
                    };
                });
                promises.push(p);
            }
        });

        Promise.all(promises).then(() => {
            setColors(newColors);
        });

        return () => {
            fac.destroy();
        };
    }, []);

    return (
        <ColorContext.Provider value={{ colors }}>
            {children}
        </ColorContext.Provider>
    );
};
